module.exports = __webpack_public_path__ + "img/app_7.1168d96b.jpg";